<template>
  <div class="order">
    <van-tabs
      v-model="active"
      color="#47d3ff"
      line-width="2rem"
      title-active-color="#47d3ff"
      swipe-threshold="3"
      :sticky="true"
      @click="getTab"
    >
      <van-tab :title="c.name" v-for="(c, i) in statusList" :key="i">
        <template v-if="i == active">
          <load-list :interFace="interFace">
            <template v-slot:list="props">
              <div
                v-for="(item, index) in props.list"
                :key="index"
                class="list"
                @click="toDetail(item.id)"
              >
                <van-swipe-cell>
                  <div class="list-cell">
                    <div class="list-left">
                      <img :src="$IMG_PATH + item.img[0]" alt="" />
                      <!-- <img :src="item.img" alt="" /> -->
                    </div>
                    <div class="list-right">
                      <span class="point-name"
                        >督查点位：<span style="color: #78c0ff">{{
                          item.point_name
                        }}</span></span
                      >
                      <span
                        >考察内容：<span
                          class="content"
                          style="color: #78c0ff"
                          >{{ item.cate_name }}</span
                        ></span
                      >
                      <span class="address">地址: {{ item.address }}</span>
                      <div class="sta">
                        <span
                          class="sta-0"
                          v-for="(c, i) in item.tags"
                          :key="i"
                        >
                          {{ c }}</span
                        >
                      </div>
                      <span style="color: #999; font-size: 0.24rem">{{
                        item.add_time_text
                      }}</span>
                    </div>
                  </div>
                  <template #right v-if="i == 0 && item.is_refuse == 0">
                    <van-button
                      square
                      type="danger"
                      text="退单"
                      class="btn-left"
                      @click="delate(item.id)"
                    />
                    <van-button
                      square
                      type="primary"
                      text="去处理"
                      class="btn-right"
                      @click="toDetail(item.id)"
                    />
                  </template>
                </van-swipe-cell>
              </div>
            </template>
          </load-list>
        </template>
      </van-tab>
    </van-tabs>
    <van-dialog
      v-model="showAlert"
      title="退单理由"
      show-cancel-button
      @confirm="subDel"
    >
      <van-field
        v-model="message1"
        rows="2"
        autosize
        type="textarea"
        maxlength="100"
        placeholder="请输入理由"
        show-word-limit
      />
    </van-dialog>
  </div>
</template>

<script>
import LoadList from "@/components/SearchLoadList";
import { getMyEventOrder, changeWork } from "../api";
import { Dialog } from "vant";
import { Toast } from "vant";
export default {
  components: {
    LoadList,
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      interFace: {
        api: getMyEventOrder,
        params: {
          status: 1,
        },
      },
      active: 0,
      statusList: [
        { status: 1, name: "待处理" },
        { status: 2, name: "已反馈" },
        { status: 3, name: "整改不合格" },
        { status: 4, name: "整改合格" },
      ],
      showAlert: false,
      delateId: "",
      message1: "",
    };
  },
  methods: {
    subDel() {
      if (!this.message1) {
        Toast.fail("请输入退单理由");
      } else {
        let that = this;
        this.showAlert = false;
        Toast.loading("提交中");
        let params = {
          type: 1,
          id: this.delateId,
          content: this.message1,
          token: window.localStorage.getItem("token"),
        };
        changeWork(params).then((res) => {
          console.log("res", res);
          if (res.code == 0) {
            Toast.success("退单成功");
            setTimeout(() => {
              that.$router.replace("/myEventOrder");
            }, 1200);
          }
          this.message1 = "";
          this.delateId = "";
        });
      }
    },
    delate(id) {
      this.showAlert = true;
      this.delateId = id;
    },
    getTab(name, title) {
      console.log(name, title);
      this.$set(this.interFace.params, "status", name + 1);
    },
    toDetail(id) {
      this.$router.push({
        name: "eventDetail",
        params: {
          id: id,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.order {
  width: 100%;
  /deep/ .van-tab {
    width: 30%;
  }
  .list {
    width: calc(100% - 0.3rem);
    height: 2.6rem;
    margin: 0 auto;
    padding: 0.2rem 0.28rem 0;
    background-color: #fff;
    display: flex;
    margin-top: 0.3rem;
    border-radius: 0.16rem;
    .list-cell {
      width: 100%;
      height: 2.3rem;
      background-color: #fff;
      display: flex;
      .list-left {
        width: 2.82rem;
        height: 1.92rem;
        img {
          width: 100%;
          height: 100%;
          margin-top: 0.2rem;
          border-radius: 0.12rem;
        }
      }
      .list-right {
        width: calc(100% - 2.82rem);
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        padding-left: 0.5rem;
        color: #333333;
        font-size: 0.26rem;
        .point-name {
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          word-break: break-all;
        }
        .address {
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          word-break: break-all;
        }
        .sta {
          // height: 0.44rem;
          display: flex;
          > span:first-child {
            margin-left: 0;
          }
          .sta-0 {
            max-width: 1.4rem;
            text-align: center;
            display: block;
            background-color: #fba738;
            color: #fff;
            font-size: 0.22rem;
            padding: 0.04rem;
            margin-left: 0.1rem;
          }
        }

        .sta-1 {
          width: 1.4rem;
          text-align: center;
          display: block;
          background-color: #fba738;
          color: #fff;
          font-size: 0.22rem;
          padding: 0.04rem 0;
        }
        .content {
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          word-break: break-all;
        }
      }
    }
    .btn-left {
      height: 100%;
      line-height: 2.3rem;
      border: none;
      background-color: #fdae5a;
    }
    .btn-right {
      height: 100%;
      line-height: 2.3rem;
      border: none;
      background-color: #3b95fc;
    }
  }
}
</style> 